var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tile-content tile-content-secondary"},[_vm._v("Stop the customer's active subscriptions not only cancels renewals, but also deactivates the subscription(s) immediately (sets the end time to when the rule action runs).")])}
var staticRenderFns = []

export { render, staticRenderFns }